<!-- Full-screen splash while the session check is in flight.
     Matches the login page background so there is no visual flash. -->
<div class="auth auth-verifying" *ngIf="isVerifying">
  <mat-progress-spinner mode="indeterminate" [diameter]="44" [strokeWidth]="4"></mat-progress-spinner>
</div>

<div class="auth" *ngIf="!isVerifying">
  <mat-card class="auth-card" appearance="outlined">
    <div class="brand">
      <img class="logo" src="assets/white-green.png" alt="Visual Price Estimator logo" />
      <h1>Visual Price Estimator</h1>
      <p class="subtitle">Sign in to continue</p>
    </div>

    <form class="form" [formGroup]="accessForm" (ngSubmit)="signIn()" novalidate>
      <mat-form-field appearance="outline" class="full">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="you@company.com" formControlName="email" autocomplete="email" required />
        <mat-error *ngIf="accessForm.get('email')?.hasError('required')">Email is required.</mat-error>
        <mat-error *ngIf="accessForm.get('email')?.hasError('email') && !accessForm.get('email')?.hasError('required')">Enter a valid email.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full">
        <mat-label>Password</mat-label>
        <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" autocomplete="current-password" required />
        <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'">
          <!-- Inline eye icons so no MatIconModule is required -->
          <svg *ngIf="hidePassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z" fill="currentColor"/>
            <circle cx="12" cy="12" r="3" fill="white"/>
          </svg>
          <svg *ngIf="!hidePassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path d="M2 5.27 3.28 4l16.97 16.97L19.97 22l-2.53-2.53C15.8 20.17 14 21 12 21 5 21 2 14 2 14s.87-1.94 2.54-3.82L2 5.27zM12 7c7 0 10 7 10 7-.44.98-1.17 2.27-2.2 3.5L18 15.7C18.63 14.9 19.1 14 19.1 14S16 7 12 7c-.69 0-1.35.1-1.97.27L8.73 5.97C9.79 5.66 10.86 5.5 12 5.5V7z" fill="currentColor"/>
          </svg>
        </button>
        <mat-error *ngIf="accessForm.get('password')?.hasError('required')">Password is required.</mat-error>
      </mat-form-field>

      <button class="full cta" mat-raised-button color="primary" type="submit" [disabled]="isLoading || accessForm.invalid">
        <span *ngIf="!isLoading">Continue</span>
        <mat-progress-spinner *ngIf="isLoading" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
      </button>

      <div class="server-error" *ngIf="showMessage" role="alert" aria-live="polite">{{ errorMessage }}</div>

      <div style="text-align:center; margin-top:8px;">
        <a routerLink="/request-access">Request access</a>
      </div>
    </form>
  </mat-card>
</div>

